// import { copy } from 'dot-object';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import CopyWellSelectTable from 'src/Components/Main/WellWorkflow/CopyWellSelectTable/CopyWellSelectTable';
import { ITest } from 'src/Interfaces/TestInterface';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';


@inject('stores')
@observer
class CopyTestDataModal extends React.Component {

    public props: any;

    private WellsStore: WellsStore;
    private TestsStore: TestsStore;
    private MessageStore: MessageStore;

    public state = {
        copyPitVolume: true,
        copyPumps: true,
        copySolids: true,
        copyTanks: true,
        copyVolOwed: true,
    };
    constructor(props: any) {
        super(props);
        this.WellsStore = props.stores.WellsStore;
        this.TestsStore = props.stores.TestsStore;
        this.MessageStore = props.stores.MessageStore;
    }

    private renderCopyCheckbox = (field: string, label: string) => {
        const checked = this.state[field];
        return (
            <div>
        <FormGroup check={true} inline={true}>
            <Label check={true}>
                <Input
                    name={field}
                    id={field}
                    type="checkbox"
                    onChange={this.handleSelect(field)}
                    checked={checked}
                    />{label}
            </Label>
        </FormGroup>
        </div>
        );
    }

    private handleSelect = (field: string) => () => {
        const val = this.state[field];
        this.setState({
            [field]: !val
        });
    }

    @action
    public saveData = async () => {
        const well = this.WellsStore.copyWell;
        if (well) {
            const testList = await this.TestsStore.getTestsCopy(well.id);
            if (testList && testList[0]) {
                const latestTest = await this.TestsStore.getCopyTestDetails(testList[0].id, well.id);
                const currTest = this.TestsStore.test;
                const { copyPumps, copySolids, copyTanks, copyVolOwed, copyPitVolume } = this.state;
                
                if (copyPumps) {
                    this.copyPumps(latestTest, currTest);
                }

                if (copySolids) {
                    this.copySolids(latestTest, currTest);
                }

                if (copyTanks) {
                    this.copyTanks(latestTest, currTest);
                }
                if (copyVolOwed){
                    this.copyVolOwed(latestTest, currTest);
                }
                if (copyPitVolume){
                    this.copyPitVolume(latestTest, currTest);
                }

                const savedTest = this.TestsStore.updateTestModel(currTest, this.WellsStore.well.id);
                
                if (await savedTest) {
                    this.MessageStore.addMessage('Data Copied Successfully', 'success');
                }
            }
        }
        
        this.toggleModal();
    }

    public copyPitVolume = (copyTest: ITest, currTest: ITest) => {
        if (copyTest.pumpData && copyTest.pumpData.pitVolume){
            currTest.pumpData.pitVolume = DeepCopy(copyTest.pumpData.pitVolume);
        }
    }

    public copyPumps = (copyTest: ITest, currTest: ITest) => {
        if (copyTest.pumpData && copyTest.pumpData.pumps) {
            currTest.pumpData.pumps = DeepCopy(copyTest.pumpData.pumps);
            currTest.pumpData.pumps.forEach(pump => pump.id = '');
        }
    }

    public copySolids = (copyTest: ITest, currTest: ITest) => {
        if (copyTest.solidsControlEquips) {
            currTest.solidsControlEquips = DeepCopy(copyTest.solidsControlEquips);
            currTest.solidsControlEquips.forEach(sce => sce.id = '');
        }
    }

    public copyTanks = (copyTest: ITest, currTest: ITest) => {
        if (copyTest.externalStorage) {
            currTest.externalStorage = DeepCopy(copyTest.externalStorage);
            currTest.externalStorage.forEach(ext => {
                ext.id = '';
                ext.previousFluidAmount = 0;
                ext.todayFluidAmount = 0;
                ext.xferIn = '';
                ext.xferOut = '';
            });
        }
    }

    public copyVolOwed = (copyTest: ITest, currTest: ITest) => {
        const copyVol = copyTest.volumeAccounting.volOwedToPlant;
        const copyPrev = copyTest.volumeAccounting.previousVolOwedToPlant;
        if (copyVol !== 0) {
            currTest.volumeAccounting.previousVolOwedToPlant = DeepCopy(copyTest.volumeAccounting.volOwedToPlant);
        } else if (copyPrev !== 0) {
          currTest.volumeAccounting.previousVolOwedToPlant = DeepCopy(copyTest.volumeAccounting.previousVolOwedToPlant);
        }
    }
    

    public toggleModal = () => {
        this.setState({
            copyPitVolume: true,
            copyPumps: true,
            copySolids: true,
            copyTanks: true,
            copyVolOwed: true,
        });
        this.props.toggle();
    }

    public clearSelections = () => {
        this.setState({
            copyPitVolume: true,
            copyPumps: true,
            copySolids: true,
            copyTanks: true,
            copyVolOwed: true,
        });
    }

    public render() {
        const open = this.props.open;
        const toggle = this.toggleModal;
        const copyWell = this.WellsStore.copyWell;
        if (open) {
            return (
                <Modal size="lg" isOpen={open} toggle={toggle} backdrop="static">
                    <ModalHeader toggle={toggle}>
                        Copy Well Test Data
                    </ModalHeader>
                    <ModalBody>
                        <CopyWellSelectTable onClear={this.clearSelections} />
                        {
                            copyWell &&
                            this.renderCopyCheckbox('copyPumps', 'Pumps')
                        }
                        {
                            copyWell &&
                            this.renderCopyCheckbox('copySolids', 'Solids Control Devices')
                        }
                        {
                            copyWell &&
                            this.renderCopyCheckbox('copyTanks', 'External Storage Tanks')
                        }
                        {
                            copyWell &&
                            this.renderCopyCheckbox('copyVolOwed', 'Vol Owed To Plant')
                        }
                        {
                            copyWell &&
                            this.renderCopyCheckbox('copyPitVolume', 'Pit Volume')
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={toggle}>Cancel</Button>
                        <Button color="primary" disabled={copyWell === undefined} onClick={this.saveData}>Save Data</Button>
                    </ModalFooter>
                </Modal>
            );
        }
        return '';
    }
}

export default CopyTestDataModal;


// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/WellData/CopyTestDataModal/CopyTestDataModal.tsx